import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {connect} from "trim-redux";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import withWidth from "@material-ui/core/withWidth/withWidth";
import Typography from "@material-ui/core/Typography/Typography";
import {currencySymbol} from "../../../../config/values";
import {Translate} from "../../../../config/Translate";
import Link from "@material-ui/core/Link/Link";
import Button from "@material-ui/core/Button/Button";
import ParticipateInFestivalButton from "./ParticipateInFestivalButton";

class FestivalItem extends React.Component {
    render(){
        let {festival} = this.props;
        return (
            <div
                className="slide_show_item banner_item"
            >
                <img src={`${defaultVariabls.uploads}/FileManager/${festival.thumbnail.name}.${festival.thumbnail.extension}`}/>
                <h3>{festival.name}</h3>
                <strong>{festival.value} {festival.type === "percent" ? "%" : currencySymbol}</strong>
                <Typography>{festival.description}</Typography>
                <div className="controller">
                    <Button
                        component={Link}
                        href={`${defaultVariabls.website}/festival/${festival.slug}`}
                        color="primary"
                        varaint="outlined"
                    >
                        {Translate.viewFestivalPage}
                    </Button>
                    <ParticipateInFestivalButton id={festival.id}/>
                </div>
            </div>
        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(FestivalItem)))));